export default __webpack_public_path__ + "static/media/bulkmicrobulk-temp.c2ffde13.JPG";